import React, { useEffect, useState } from 'react';

import { AuthHistoryTable } from './components/table/AuthHistoryTable';
import TwoFactorAuthenticationSection from './components/TwoFactorAuthenticationSection';
import { useBlockId } from '../../components/blocks/BlockState';
import { useStateSelector } from '../../data/global/dataSelectors';

export const AccountSecurity: React.FunctionComponent<{}> = ({}) => {
  const [shouldStackColumns, setShouldStackColumns] = useState<boolean>(false);

  const twoFactorAuthenticationState = useStateSelector(s => s.account.profile.current && s.account.profile.current.twoFactorAuthenticationState);

  const blockId = useBlockId();

  useEffect(() => {
    const blockElement = document.getElementById(`block-${blockId}`);

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.contentRect.width < 555) {
          setShouldStackColumns(true);
        } else {
          setShouldStackColumns(false);
        }
      })
    });

    if (blockElement) {
      resizeObserver.observe(blockElement);
    }

    return () => resizeObserver.disconnect();
  }, []);

  return (
    <div className="container-fluid" style={{ height: '100%' }}>
      <div className="row">
        {twoFactorAuthenticationState && (
          <div className={`${shouldStackColumns ? 'col-12' : 'col-6'}`}>
            <TwoFactorAuthenticationSection />
          </div>
        )}
        <div className={`${(shouldStackColumns || !twoFactorAuthenticationState) ? 'col-12' : 'col-6'}`}>
          <AuthHistoryTable />
        </div>
      </div>
    </div>
  );
};
